import React from 'react';
import { categories } from '../mockData';
import { Leaf, Cigarette, Candy, Wind, Gem, Droplet, Sparkles, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';

const iconMap = {
  'flower': Leaf,
  'pre-rolls': Cigarette,
  'edibles': Candy,
  'vaporizers': Wind,
  'concentrates': Gem,
  'tinctures': Droplet,
  'topicals': Sparkles,
  'accessories': Wrench
};

const CategoriesSection = () => {
  return (
    <section id="categories" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-neutral-800 font-semibold mb-2 uppercase tracking-wide">Know what you're looking for?</p>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900">
            Shop By Category
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {categories.map((category) => {
            const IconComponent = iconMap[category.slug];
            return (
              <Link
                to="/#shop"
                key={category.id}
                className="group relative block rounded-xl bg-gradient-to-br from-neutral-50 to-neutral-100 p-6 shadow-md transition-all duration-300 hover:-translate-y-1 hover:from-neutral-800 hover:to-black hover:shadow-xl md:p-8"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="mb-4 rounded-full bg-white/80 p-4 transition-colors group-hover:bg-white/90">
                    {IconComponent && (
                      <IconComponent className="h-8 w-8 text-neutral-800 group-hover:text-neutral-200 md:h-10 md:w-10" />
                    )}
                  </div>
                  <h3 className="text-lg font-bold text-neutral-900 transition-colors group-hover:text-white md:text-xl">
                    {category.name}
                  </h3>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
